/* esm.sh - applesauce-core@5.2.0/helpers/url */
export * from "/*applesauce-core@5.2.0/esnext/helpers/url.mjs";
